<template>
  <b-tab :title="__('OnInvoice')">
    <OnInvoice />
  </b-tab>
</template>

<script>
import OnInvoice from './Settings';

export default {
  components: {
    OnInvoice,
  },
};
</script>
